export default __webpack_public_path__ + "static/media/logo.d17b218d.svg";